import React, { useEffect, useState } from "react";
import Member from "./Member";
import { fetchSellerMembers } from "../../../../../Features/settingsSlice";
import { useDispatch, useSelector } from "react-redux";

function MembersList() {
  const [openDropdownMemberId, setOpenDropdownMemberId] = useState(null);

  const dispatch = useDispatch();
  const sellerMembers = useSelector(
    (state) => state.settings.sellerMembers.list
  );

  useEffect(() => {
    dispatch(fetchSellerMembers());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="border border-[#EAEAEA] rounded-xl">
      <div className="w-full flex font-semibold text-[16px] leading-8 text-[#666666] bg-[#F5F5F5]">
        <div className="w-[28%] px-4 py-2">
          <p>Member Name</p>
        </div>

        <div className="w-[20%] px-4 py-2">
          <p>Role</p>
        </div>

        <div className="w-[20%] px-4 py-2">
          <p>Joined</p>
        </div>

        <div className="w-[20%] px-4 py-2">
          <p>Last Login</p>
        </div>

        <div className="w-[12%] px-4 py-2"></div>
      </div>

      {sellerMembers?.map((member) => {
        return (
          <Member
            member={member}
            key={member.id}
            openDropdownMemberId={openDropdownMemberId}
            setOpenDropdownMemberId={setOpenDropdownMemberId}
          />
        );
      })}
    </div>
  );
}

export default MembersList;
